import './css/footer.css';

function Footer(props){
    return(
        <>
            
                <footer className={`${props.className}`}>
                    <div className="row">
                        <div className="upper">
                            <div>
                                <h1> دائما هنا لمساعدتك
                                </h1>
                                <h2> تواصل معنا عن طريق أي وسيلة تواصل تناسبك
                                </h2>
                            </div>

                            <div>
                                <div>
                                    <i className="fa-solid fa-circle-info"></i>
                                    <div>
                                        <h1> مركز المساعدة
                                        </h1>
                                        <h2>help.machinery.com</h2>
                                    </div>
                                </div>


                                <div>
                                    <i className="fa-solid fa-phone"></i>
                                    <div>
                                        <h1>رقم الاتصال
                                        </h1>
                                        <h2>13655</h2>
                                    </div>
                                </div>



                                <div>
                                    <i className="fa-solid fa-envelope"></i>
                                    <div>
                                        <h1>البريد الألكتروني

                                        </h1>
                                        <h2>machinery@gmail.com</h2>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="middle">
                            <div className="row">

                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                        <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>



                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                    <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>




                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                    <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>



                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                    <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>




                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                    <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>




                                <div className="col-lg-2 col-md-3 col-xs-6 col-sm-6">
                                    <div className="links">
                                    <h1> مكياج أحلى ساكورا </h1>
                                        <ul>
                                            <li><a href="sub_category"> مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                            <li><a href="sub_category">مكياج أحلى ساكورا</a></li>
                                        </ul>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </div>

                        <div className="row">
                            <div className="bottom">
                                <h1> تواصل معنا </h1>
                                <ul>
                                    <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i className="fa-brands fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                                    <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                                </ul>
                            </div>
                        </div>




                    </div>
            </footer>



        </>
    )
}

export default Footer;